<script setup>
import { useRoute } from '@js/utils/route';
import { ref } from 'vue';

const { task, action, callback } = defineProps({
    task: {
        type: Object,
        required: true,
    },
    action: {
        type: String,
        required: false,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const loading = ref(false);

function toggleTaskStatus() {
    loading.value = true;

    axios
        .post(
            route(
                action === 'process'
                    ? 'front.projectManagement.task.postProcessTask'
                    : 'front.projectManagement.task.postCloseTask',
                { task: task.id },
            ),
        )
        .then(() => {
            if (callback) {
                callback();
            }
        })
        .finally(() => {
            loading.value = false;
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="toggleTaskStatus" :loading="loading" />
</template>
